// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3maxo","paramInput":"JobSimulator_paramInput__J1R_m","input":"JobSimulator_input__W6ImI"};